import {
  AfterViewInit,
  Directive,
  EventEmitter,
  HostListener,
  Input,
  Output
} from '@angular/core';

@Directive({
  selector: '[idpClickOutside]',
  standalone: true
})
export class ClickOutsideDirective implements AfterViewInit {
  @Output() appClickOutside = new EventEmitter<{ id: string }>();
  @Input() isMobile = false;
  @Input() set includedSelectors(selectors: string[]) {
    if (selectors && selectors.length > 0) {
      this.includeSelectors = selectors;
    }
  }

  @Input() APP_DISABLE_LEGACY = true;

  private includeSelectors = [
    'idp-navigation-links',
    'widgets-container',
    'idp-search-flights',
    'idp-my-trips-container',
    'idp-check-in-container',
    'idp-flight-status-container',
    'idp-secondary-navigation-links',
    'idp-search-wrapper',
    'idp-login-modal-wrapper',
    'idp-notification'
  ];

  @HostListener('document:click', ['$event.target'])
  onClick(targetElement: EventTarget | null): void {
    if (!this.isValidClick(targetElement)) {
      return;
    }

    const shouldEmitClickOutside = !this.isClickedInValidArea(
      targetElement as HTMLElement
    );

    if (!this.APP_DISABLE_LEGACY && shouldEmitClickOutside) {
      this.appClickOutside.emit({ id: '' });
    }
  }

  private isValidClick(targetElement: EventTarget | null): boolean {
    if (!targetElement || !(targetElement instanceof HTMLElement)) {
      return false;
    }
    return !this.isMobile;
  }

  ngAfterViewInit(): void {
    this.checkAppDisabledLegacy();
  }

  checkAppDisabledLegacy(): void {
    if (this.APP_DISABLE_LEGACY) {
      this.appClickOutside.emit({ id: 'book' });
    } else {
      this.appClickOutside.emit({ id: '' });
    }
  }

  private isClickedInValidArea(element: HTMLElement): boolean {
    const isOverlay = element.classList[0]?.includes('cdk-overlay');
    const isAura = this.hasAuraClass(element);
    const isIncludedElement = this.checkIncludedElements(element);

    return isOverlay || isAura || isIncludedElement;
  }

  private checkIncludedElements(element: HTMLElement): boolean {
    return this.includeSelectors.some((selector) =>
      this.getElements(selector).some((el) => el.contains(element))
    );
  }

  private getElements(selector: string): Element[] {
    const elements = document.getElementsByTagName(selector);
    if (elements.length > 0) {
      return Array.from(elements);
    }
    return [
      ...Array.from(document.querySelectorAll(`.${selector}`)),
      ...Array.from(document.querySelectorAll(`#${selector}`))
    ];
  }

  private hasAuraClass(element: HTMLElement): boolean {
    if (this.elementHasAuraClass(element)) {
      return true;
    }

    if (
      element.parentElement &&
      this.elementHasAuraClass(element.parentElement)
    ) {
      return true;
    }
    return false;
  }

  private elementHasAuraClass(element: HTMLElement): boolean {
    return Array.from(element.classList || []).some((className) =>
      className.includes('aura')
    );
  }
}
